import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRight } from "lucide-react";

export default function NotFound() {
    const { t } = useTranslation();
    return (
        <div data-testid="not-found-page" className="pt-28 min-h-[80vh] flex items-center">
            <section className="container-rail max-w-3xl mx-auto py-16 text-center space-y-10">
                <div className="text-overline text-[#A3A3A3]">{t("notfound.label")}</div>
                <h1 className="text-display text-[10rem] sm:text-[14rem] leading-[0.85] text-[#F4F4F0]">
                    <span className="text-display-italic text-[#A3A3A3]">{t("notfound.title_italic")}</span>
                    <br />
                    {t("notfound.title_main")}
                </h1>
                <p className="text-[#A3A3A3] text-lg max-w-md mx-auto leading-relaxed">
                    {t("notfound.body")}
                </p>
                <div className="flex flex-wrap justify-center gap-3 pt-4">
                    <Link to="/" data-testid="notfound-home" className="btn-ghost">
                        {t("notfound.return_home")}
                    </Link>
                    <Link to="/shop" data-testid="notfound-shop" className="btn-primary">
                        {t("notfound.browse_catalogue")} <ArrowRight className="h-4 w-4" />
                    </Link>
                </div>
            </section>
        </div>
    );
}
